import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// Compatibility shim for API response format migration:
// when backend returns { status: "success" }, expose a derived boolean success.
if (typeof window !== 'undefined' && typeof window.fetch === 'function' && !window.__apiSuccessCompatPatched) {
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const originalJson = response.json.bind(response);

    response.json = async () => {
      const data = await originalJson();

      if (
        data &&
        typeof data === 'object' &&
        !Array.isArray(data) &&
        typeof data.success === 'undefined' &&
        typeof data.status === 'string'
      ) {
        return {
          ...data,
          success: data.status.toLowerCase() === 'success',
        };
      }

      return data;
    };

    return response;
  };

  window.__apiSuccessCompatPatched = true;
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)